require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-photo-video-premium-photography.json") })
        }
      }, "path---services-photo-video-premium-photography");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-photo-video-premium-photography!./.cache/json/services-photo-video-premium-photography.json
// module id = 762
// module chunks = 231608221292675